import { Form, TimePicker } from 'antd'
import React from 'react'

const SettingsCheckIn = (props) => {
  return (
    <>
      <Form.Item label='Check-in Time' name='checkin' hidden={props.hidden} initialValue='12:00 PM'>
        <TimePicker format='hh:mm A' minuteStep={15} />
      </Form.Item>
      <Form.Item label='Scratch Time' name='scratch' hidden={props.hidden} initialValue='01:00 PM'>
        <TimePicker format='hh:mm A' minuteStep={15} />
      </Form.Item>
    </>
  )
}

export default SettingsCheckIn
